module.exports = __webpack_public_path__ + "img/famille1.cdf97398.jpg";